export default __webpack_public_path__ + "f9e8377be866fd332286d79c69e1f3a2.svg";